import React, { Component } from 'react';
import { connect } from 'react-redux';
import LoadingOverlay from 'react-loading-overlay';

import { fetchAgentToken, checkURLStatus } from '../store/actions';
import { returnHostUrl } from '../util/axiosHelper';

import { AccessDenied } from './AccessDenied';
import { Header } from './Header';
import Landing from './Landing';
import packageJson from '../../package.json';

export class App extends Component {
  constructor(props) {
    super(props);
    this.loadingOverlayRef = React.createRef();

    const {
      agentIsLoading,
      agentReportIsLoading,
      accntReportIsLoading,
      accountIsLoading,
      isSwitchTypeLoading,
      tokenIsLoading,
    } = this.props;

    this.isLoading =
      accountIsLoading ||
      agentIsLoading ||
      accntReportIsLoading ||
      agentReportIsLoading ||
      isSwitchTypeLoading ||
      tokenIsLoading;

    this.didFocusLoadingRef = false;
  }

  componentDidMount() {
    console.log('FE Version: ', packageJson.version);
    returnHostUrl();
    this.props.checkURLStatus();

    if (this.isLoading && !this.didFocusLoadingRef) {
      this.loadingOverlayRef.current.focus();
      this.didFocusLoadingRef = true;
    }
  }

  componentDidUpdate() {
    if (this.isLoading && !this.didFocusLoadingRef) {
      this.loadingOverlayRef.current.focus();
      this.didFocusLoadingRef = true;
    }
  }

  render() {
    const {
      agentIsLoading,
      agentReportIsLoading,
      accntReportIsLoading,
      accountIsLoading,
      isSwitchTypeLoading,
      user: { email },
      tokenIsLoading,
      tokenError,
    } = this.props;

    return (
      <div className="container">
        <Header />
        <LoadingOverlay
          ref={this.loadingOverlayRef}
          active={
            accountIsLoading ||
            agentIsLoading ||
            accntReportIsLoading ||
            agentReportIsLoading ||
            isSwitchTypeLoading ||
            tokenIsLoading
          }
          spinner
          text={tokenIsLoading ? 'Fetching your token...' : 'Loading your content...'}
        >
          {email && !tokenError ? <Landing /> : <AccessDenied message={tokenError} />}
        </LoadingOverlay>
      </div>
    );
  }
}

export function mapStateToProps({
  access: { error: tokenError, isLoading: tokenIsLoading, user },
  account: { isLoading: accountIsLoading },
  agent: { isLoading: agentIsLoading },
  switchType: { isLoading: isSwitchTypeLoading },
  targetAccountReport: { isLoading: accntReportIsLoading },
  targetAgentReport: { isLoading: agentReportIsLoading },
}) {
  return {
    accountIsLoading,
    agentIsLoading,
    accntReportIsLoading,
    agentReportIsLoading,
    isSwitchTypeLoading,
    tokenIsLoading,
    tokenError,
    user,
  };
}

export default connect(mapStateToProps, { fetchAgentToken, checkURLStatus })(App);
